"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decideIfFullWidthOrFullHeightImg = void 0;
var calcAspectRatio_1 = require("./calcAspectRatio");
var decideIfFullWidthOrFullHeightImg = function (_a) {
    var imgWidth = _a.imgWidth, imgHeight = _a.imgHeight, wrapperAspectRatio = _a.wrapperAspectRatio;
    var wrapperAspectRatioCalc = (0, calcAspectRatio_1.calcAspectRatio)(wrapperAspectRatio);
    var imgRatioCalc = imgWidth / imgHeight;
    //if image is relatively 'narrower' than the wrapper, then it should take full width
    if (wrapperAspectRatioCalc > imgRatioCalc) {
        return "fullWidth";
    }
    //if they are exactly the same, then image can take fullWidth
    else if (imgRatioCalc === wrapperAspectRatioCalc) {
        return "fullWidth";
    }
    //if image is relatively 'wider' than the wrapper, then it should take full height
    else if (imgRatioCalc > wrapperAspectRatioCalc) {
        return "fullHeight";
    }
};
exports.decideIfFullWidthOrFullHeightImg = decideIfFullWidthOrFullHeightImg;
